'use client';
import React, { useEffect, useState } from 'react';
import { useTheme } from './ThemeProvider';
import { Spin } from 'antd';

export default function ThemeLoadingGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const theme = useTheme();

  if (!theme) {
    // ยังไม่มี theme → loading
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-white">
        <Spin size="large" tip="กำลังโหลด..." />
      </div>
    );
  }

  // มี theme แล้ว → render ปกติ
  return <>{children}</>;
}
